import { OfferOption, OfferOptionType } from "./Types/offerOptionsTypes";

export const offerOptionTypeValues: OfferOptionType | OfferOption = {
	id: 0,
	name: "",
	offerOptionsValues: [],
	offerOptionsTypeId: 0,
	offerOptionsValueId: 0,
};
